import React from 'react';
import './CoursePackageTile.css';

function CoursePackageTile({ course, onSelect, isSelected }) {
    const tileClasses = `course-tile ${isSelected ? 'selected' : ''}`;

    return (
        <div
            id={`course-tile-${course.id}`}
            className={tileClasses}
            onClick={() => onSelect(course)}
        >
            <div className="course-tile-icon">{course.icon}</div>
            <h3 className="course-tile-name">{course.name}</h3>
            <p className="course-tile-description">{course.tileDescription}</p>
            <button className="course-tile-button">
                {isSelected ? 'View Details Below' : 'Learn More'}
            </button>
        </div>
    );
}

export default CoursePackageTile;